import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { UseFormReturn } from 'react-hook-form';
import { CustomerFormType } from './CustomerFormTypes';
import { Info } from 'lucide-react';

interface RepresentativeFieldsProps {
  form: UseFormReturn<CustomerFormType>;
}

export function RepresentativeFields({ form }: RepresentativeFieldsProps) {
  return (
    <div className="space-y-4 mt-6 p-4 border rounded-lg bg-muted/30">
      <div className="flex items-center gap-2">
        <h3 className="text-lg font-medium">Contact Person</h3>
        <div className="flex items-center gap-1 text-xs text-muted-foreground bg-muted px-2 py-1 rounded">
          <Info className="h-3 w-3" />
          Internal Use Only
        </div>
      </div>
      
      <div className="grid grid-cols-2 gap-4">
        <FormField
          control={form.control}
          name="representative_first_name"
          render={({ field }) => (
            <FormItem>
              <FormLabel>First Name</FormLabel>
              <FormControl>
                <Input {...field} value={field.value || ''} placeholder="First name" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="representative_last_name"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Last Name</FormLabel>
              <FormControl>
                <Input {...field} value={field.value || ''} placeholder="Last name" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="representative_position"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Position / Role</FormLabel>
              <FormControl>
                <Input {...field} value={field.value || ''} placeholder="e.g. Project Manager" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="representative_phone"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Phone</FormLabel>
              <FormControl>
                <Input {...field} value={field.value || ''} placeholder="Contact phone" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="representative_email"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Email</FormLabel>
              <FormControl>
                <Input {...field} value={field.value || ''} placeholder="Contact email" type="email" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
}
